module.exports = __webpack_public_path__ + "img/18.c5d2bd47.png";